export default __webpack_public_path__ + "static/media/6G.f7ec1912.png";